export default {
    total: 'Total {count}',
    perPage: '{count}/page',
    goTo: 'Aller à',
    go: 'Go',
};
